export default __webpack_public_path__ + "static/media/Apercu-MediumItalic.d81f15c4.otf";